<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户组管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="listData" highlight-current-row
              v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column sortable prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="title" label="用户组名称">
      </el-table-column>
      <el-table-column align="center" prop="status" label="是否启用" min-width="50">
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0">否</span>
          <span v-else>是</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="menuAccess(scope.row)">菜单权限</el-button>
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser( scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="用户组名称" prop="title">
          <el-input size="small" v-model="editForm.title" auto-complete="off"
                    placeholder="用户组名称"></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="status">
          <el-radio :label="1" v-model="editForm.status">是</el-radio>
          <el-radio :label="0" v-model="editForm.status">否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
          保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 菜单权限 -->
    <el-dialog title="菜单权限" :visible.sync="menuAccessshow" width="40%" @click='closeDialogMenu()'>
      <div class="down-tree">
        <el-tree ref="tree" default-expand-all="" :data="RoleRight" :props="RoleRightProps"
                 :default-checked-keys="checkmenu" node-key="id" show-checkbox>
        </el-tree>
        <div slot="footer" class="dialog-footer dialog-footer1">
          <el-button size="small" @click='closeDialogMenu()'>取消</el-button>
          <el-button size="small" type="primary" :loading="loading" class="title" @click="menuPermSave">保存
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {allMenu, groups, selectedMenu, groupSave, userMenuSave, groupDelete} from '../../api/userMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        title: '',
        status: '',
        rule: '',
        id: 0
      },
      checkmenu: [],
      // 数据权限
      RoleRight: [],
      RoleRightProps: {
        children: 'children',
        label: 'name'
      },
      // rules表单验证
      rules: {
        title: [
          {required: true, message: '请输入用户组名称', trigger: 'blur'}
        ],
        status: [
          {required: true, message: '请输入权限CODE', trigger: 'blur'}
        ]
      },
      menuAccessshow: false,
      formInline: {
        page: 1,
        limit: 10,
        permissionName: '',
        permission: '',
        roleId: '0',
      },
      // 选择数据
      selectdata: [],
      uid: null,
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */
  watch: {},
  /**
   * 创建完毕
   */
  created() {
    this.loading = true
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    // 获取数据方法
    getdata(parameter) {
      // 模拟数据
      this.loading = false
      groups().then(res => {
        this.listData = res.data
      })

      // 分页赋值
      this.pageparm.currentPage = this.formInline.page
      this.pageparm.pageSize = this.formInline.limit
    },
    // 获取权限
    menuAccess: function (row) {
      this.menuAccessshow = true
      this.uid = row.id
      allMenu()
        .then(res => {
          if (res.code == 200) {
            this.changemenu(res.data)
            this.RoleRight = this.changeArr(res.data)

            selectedMenu({id: row.id}).then(res1 => {
              if (res1.code == 200) {
                this.checkmenu = res1.data
              }
            })
          } else {
            this.$message({
              type: 'info',
              message: res.message
            })
          }
        })
        .catch(err => {
          this.loading = false
        })
    },
    // 选中菜单
    changemenu(arr) {
      let change = []
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].checked) {
          change.push(arr[i].id)
        }
      }
      this.checkmenu = change
    },
    // tree 递归
    changeArr(list) {
      var temptree = [],
        tree = [],
        items = []
      for (var i in list) {
        if (!temptree[list[i].id]) {
          var trow = {
            id: list[i].id,
            parent_id: list[i].parent_id,
            name: list[i].name,
            status: list[i].status,
            children: list[i].children
          }
          temptree[list[i].id] = trow
          items.push(trow)
        }
      }

      for (var j in items) {
        if (temptree[items[j].parent_id]) {
          temptree[items[j].parent_id]['children'].push(temptree[items[j].id])
        } else {
          tree.push(temptree[items[j].id])
        }
      }
      temptree = null
      items = null
      return tree
    },
    // 菜单权限-保存
    menuPermSave() {
      let parm = {
        id: this.uid,
        menu_id: ''
      }
      let node = this.$refs.tree.getCheckedNodes()
      let menuIds = []
      if (node.length != 0) {
        for (let i = 0; i < node.length; i++) {
          menuIds.push(node[i].id)
        }
        parm.menu_id = JSON.stringify(menuIds)
      }
      userMenuSave(parm)
        .then(res => {
          this.menuAccessshow = false
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '权限保存成功'
            })
            this.getdata(this.formInline)
          } else {
            this.$message({
              type: 'info',
              message: '权限保存失败'
            })
          }
        })
        .catch(err => {
          this.loading = false
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function (row) {
      this.editFormVisible = true
      // 深拷贝并赋值
      //this.editForm = Object.assign({}, row)
      if (row != undefined) {
        this.title = '修改'
        this.editForm.title = row.title
        this.editForm.status = row.status
        this.editForm.id = row.id
      } else {
        this.title = '添加'
        this.editForm.title = ''
        this.editForm.status = 1
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      groupSave(this.editForm)
        .then(res => {
          this.editFormVisible = false
          this.loading = false
          if (res.code == 200) {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '保存成功！'
            })
          } else {
            this.$message({
              type: 'error',
              message: '保存失败！'
            })
          }
        })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('权限管理保存失败，请稍后再试！')
        })
    },
    // 删除权限
    deleteUser(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          groupDelete({id: row.id})
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: '分组:' + row.title + '删除成功！'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: '删除失败'
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('分组删除失败,请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
    },
    // 关闭编辑、增加弹出框
    closeDialogMenu(row) {
      this.menuAccessshow = false
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.dialog-footer1 {
  margin-top: 20px;
}

.down-tree {
  height: 50vh;
  display: block;
  overflow-y: scroll;
}
</style>




// WEBPACK FOOTER //
// src/views/auth/userGroup.vue